import type { ConsoleSection } from '../../lib/api/operatorConsole';

// Console sections in the partner's words. Keys mirror the backend registry
// (LootMachine::ConsolePermissions::SECTIONS); an unknown key falls back to
// its raw name so a section added on the backend is still pickable here
// before this map catches up.
const LABELS: Partial<Record<ConsoleSection, string>> = {
  packs: 'Packs',
  offers: 'Configs — pricing & pack setup',
  categories: 'Categories',
  themes: 'Themes',
  links: 'Footer links',
  players: 'Sessions & transactions',
  shipping: 'Deliveries & shipping promotions — player names & addresses, promotional delivery prices',
  logs: 'Callback logs',
  test_players: 'Test players',
  metrics: 'Metrics — sales, GGR and your revenue',
  webhooks: 'Webhooks — event notifications to your backend',
  tracking: 'Tracking pixels — your ad pixels in the game',
  pack_builder: 'Pack Builder',
  media_kit: 'Media Kit — original pack and card artwork',
};

const PRESET_LABELS: Record<string, string> = {
  content: 'Content',
  operations: 'Operations',
  full: 'Everything',
};

export function sectionLabel(section: ConsoleSection): string {
  return LABELS[section] ?? section;
}

export function presetLabel(preset: string): string {
  return PRESET_LABELS[preset] ?? preset;
}
